const state = {
 packageRecordId:0,
 isShowSlide: true,
}

const mutations = {
  SET_PACKAGE_RECORD_ID:(state, packageRecordId)=>{
    state.packageRecordId = packageRecordId
  },
  SET_IS_SHOW_SLIDE:(state, isShowSlide)=>{
    state.isShowSlide = isShowSlide
  },
}

const actions = {
  changePackageRecordId({ commit }, packageRecordId) {
    commit('SET_PACKAGE_RECORD_ID', packageRecordId)
  },
  changeIsShowSlide({ commit }, isShowSlide) {
    commit('SET_IS_SHOW_SLIDE', isShowSlide)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/official.js